export const Marquee = ({ items, duration = 60, reverse = false, className = "", itemClass = "", sep = "✦" }) => {
  const row = [...items, ...items];
  return (
    <div className={`overflow-hidden ${className}`} aria-hidden="true">
      <div className={`marquee-track ${reverse ? "reverse" : ""}`} style={{ "--dur": `${duration}s` }}>
        {row.map((t, i) => (
          <span key={i} className={`flex items-center shrink-0 ${itemClass}`}>
            {t}
            <span className="mx-8 text-[#39FF14] text-[0.5em]">{sep}</span>
          </span>
        ))}
      </div>
    </div>
  );
};
